// =========================================================
// frontend/js/auth.js - V17.2 (SEO Optimized Landingpage)
// =========================================================
let authMode = 'landing';
/**
 * ZENTRALE AUTH-ÜBERWACHUNG
 */ firebase.auth().onAuthStateChanged(async (user)=>{
    try {
        if (user) {
            // =====================================================
            // 1. PRÜFUNG: E-MAIL VERIFIZIERT? 
            // =====================================================
            if (!user.emailVerified) {
                console.log("\uD83D\uDCE7 E-Mail noch nicht verifiziert.");
                authMode = 'needs-verification';
                // FIX: Wir merken uns die E-Mail separat, damit die App nicht denkt, wir wären voll eingeloggt!
                window.unverifiedEmail = user.email;
                window.currentUser = null;
                if (typeof render === 'function') render();
                return; // Stoppt hier! Zeigt den "Postfach prüfen" Screen.
            }
            console.log("\uD83D\uDD10 Login erkannt & verifiziert. Suche Profil...");
            const signpostDoc = await db.collection('users').doc(user.uid).get();
            if (!signpostDoc.exists) {
                console.error("\u274C Kein Profil gefunden.");
                authMode = 'login';
                if (typeof render === 'function') render();
                return;
            }
            const rootData = signpostDoc.data();
            window.currentUser = {
                uid: user.uid,
                ...rootData
            };
            if (rootData.role === 'SUPERADMIN') {
                window.activeView = 'superadmin';
                if (typeof window.loadInitialData === 'function') await window.loadInitialData();
                else if (typeof render === 'function') render();
                return;
            }
            const companyId = rootData.companyId;
            if (!companyId) {
                console.error("\u274C Keine Company ID beim User!");
                return window.logoutUser();
            }
            const [fullProfileDoc, companyDoc] = await Promise.all([
                db.collection('companies').doc(companyId).collection('users').doc(user.uid).get(),
                db.collection('companies').doc(companyId).get()
            ]);
            if (fullProfileDoc.exists && companyDoc.exists) {
                const userData = fullProfileDoc.data();
                const companyData = companyDoc.data();
                window.currentUser = {
                    uid: user.uid,
                    ...userData,
                    companyId,
                    companyName: companyData.name,
                    companySettings: companyData.settings || {}
                };
                console.log(`\u{1F4E6} Firma ${companyData.name} geladen...`);
                if (typeof window.loadInitialData === 'function') await window.loadInitialData();
            } else return window.logoutUser();
        } else window.currentUser = null;
        if (typeof render === 'function') render();
    } catch (error) {
        console.error("Auth-Fehler:", error);
    }
});
/**
 * HILFSFUNKTIONEN & STATS
 */ window.fetchGlobalImpactStats = async function() {
    try {
        console.log("\uD83C\uDF0D Berechne Live-Impact ALLER Firmen...");
        // 1. Hole alle Firmen aus der Datenbank
        const companiesSnap = await db.collection('companies').get();
        let totalGlobalCO2 = 0;
        // 2. Addiere die echten, aktuellen Werte aller Firmen zusammen
        companiesSnap.forEach((doc)=>{
            const data = doc.data();
            const companyCO2 = data.stats?.totalCO2 || 0;
            totalGlobalCO2 += parseFloat(companyCO2);
        });
        // 3. Bäume berechnen (Faustregel: ca. 12.5 kg CO2-Ersparnis entsprechen einem gepflanzten Baum)
        const totalTrees = Math.floor(totalGlobalCO2 / 12.5); // FIX: Punkt statt Komma!
        console.log(`\u{2705} Globaler Impact: ${totalGlobalCO2.toFixed(1)} kg CO2 | ${totalTrees} B\xe4ume`);
        return {
            co2: Math.floor(totalGlobalCO2),
            trees: totalTrees
        };
    } catch (e) {
        console.error("\u274C Fehler beim Berechnen der globalen Stats:", e);
        return {
            co2: 0,
            trees: 0
        };
    }
};
window.scrollToSection = function(id) {
    const container = document.getElementById('landing-scroll-container');
    if (!container) return;
    if (id === 'top') {
        container.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        return;
    }
    const el = document.getElementById(id);
    if (el) {
        const y = el.offsetTop - 100;
        container.scrollTo({
            top: y,
            behavior: 'smooth'
        });
    }
};
window.showLegalModal = function(type) {
    const title = type === 'impressum' ? 'Impressum' : 'Datenschutz';
    const text = type === 'impressum' ? `<h4 class="font-black text-slate-800 mb-2">Angaben gem\xe4\xdf \xa7 5 TMG</h4>
           <p>Musterfirma GmbH<br>Musterstra\xdfe 123<br>12345 Musterstadt</p>
           <h4 class="font-black text-slate-800 mt-6 mb-2">Kontakt</h4>
           <p>Telefon: +49 (0) 123 44 55 66<br>E-Mail: info@musterfirma.de</p>
           <p class="mt-6 text-xs text-slate-400">Hier kannst du sp\xe4ter dein echtes Impressum einf\xfcgen.</p>` : `<h4 class="font-black text-slate-800 mb-2">1. Datenschutz auf einen Blick</h4>
           <p>Allgemeine Hinweise: Die folgenden Hinweise geben einen einfachen \xdcberblick dar\xfcber, was mit deinen personenbezogenen Daten passiert, wenn du unsere App besuchst.</p>
           <h4 class="font-black text-slate-800 mt-6 mb-2">2. Datenerfassung in dieser App</h4>
           <p>Die Datenverarbeitung auf dieser Plattform erfolgt durch den App-Betreiber. Wir nehmen den Schutz deiner Daten (gem\xe4\xdf DSGVO) sehr ernst.</p>
           <p class="mt-6 text-xs text-slate-400">Hier kannst du sp\xe4ter deine echte Datenschutzerkl\xe4rung einf\xfcgen.</p>`;
    const modal = document.createElement('div');
    modal.id = 'legal-modal';
    modal.className = 'fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[200] flex items-center justify-center p-4 animate-fadeIn';
    modal.innerHTML = `
        <div class="bg-white rounded-[2rem] shadow-2xl w-full max-w-2xl flex flex-col max-h-[80vh] overflow-hidden">
            <div class="p-6 border-b border-slate-100 flex justify-between items-center bg-slate-50">
                <h3 class="text-xl font-black text-slate-800">${title}</h3>
                <button onclick="document.getElementById('legal-modal').remove()" class="text-slate-400 hover:text-slate-700 transition-colors"><i data-lucide="x" class="w-6 h-6"></i></button>
            </div>
            <div class="p-8 overflow-y-auto text-sm text-slate-600 space-y-2 leading-relaxed custom-scrollbar">
                ${text}
            </div>
            <div class="p-6 border-t border-slate-100 bg-slate-50">
                <button onclick="document.getElementById('legal-modal').remove()" class="w-full bg-slate-200 text-slate-700 py-3 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-slate-300 transition-all">Schlie\xdfen</button>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
    if (window.lucide) lucide.createIcons();
};
/**
 * REGISTRIERUNG & LOGIN
 */ window.handleRegister = async function() {
    const email = document.getElementById('regEmail')?.value.trim();
    const pass = document.getElementById('regPass')?.value;
    const companyName = document.getElementById('regCompany')?.value.trim();
    const firstName = document.getElementById('regFirst')?.value.trim();
    const lastName = document.getElementById('regLast')?.value.trim();
    const street = document.getElementById('regStreet')?.value.trim();
    const streetno = document.getElementById('regStreetNo')?.value.trim();
    const postalcode = document.getElementById('regZip')?.value.trim();
    const city = document.getElementById('regCity')?.value.trim();
    const country = document.getElementById('regCountry')?.value.trim();
    const timezone = document.getElementById('regTimezone')?.value;
    if (!email || !pass || !companyName || !firstName || !lastName || !street || !streetno || !postalcode || !city || !timezone) return alert("Bitte alle Pflichtfelder (*) ausf\xfcllen.");
    try {
        const userCredential = await firebase.auth().createUserWithEmailAndPassword(email, pass);
        const user = userCredential.user;
        // E-Mail senden!
        await user.sendEmailVerification();
        // Sichere ID erstellen
        const baseSlug = companyName.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
        const randomSuffix = Math.random().toString(36).substring(2, 7);
        const cid = `${baseSlug}-${randomSuffix}`;
        const userData = {
            uid: user.uid,
            email,
            firstName,
            lastName,
            companyName,
            companyId: cid,
            role: 'OWNER',
            prefs: {
                defaultCalendarView: 'month',
                defaultCalendarFilter: 'team'
            },
            createdAt: firebase.firestore.FieldValue.serverTimestamp()
        };
        const companyData = {
            name: companyName,
            street,
            streetno,
            postalcode,
            city,
            country,
            industry: '',
            size: '',
            logoUrl: '',
            settings: {
                workDays: [
                    1,
                    2,
                    3,
                    4,
                    5
                ],
                timezone: timezone,
                widgetUrl: null
            },
            stats: {
                totalCO2: 0
            },
            billing: {
                address: '',
                vatId: '',
                contactEmail: email
            },
            createdAt: firebase.firestore.FieldValue.serverTimestamp()
        };
        const batch = db.batch();
        batch.set(db.collection('users').doc(user.uid), {
            companyId: cid,
            role: 'OWNER'
        });
        batch.set(db.collection('companies').doc(cid), companyData);
        batch.set(db.collection('companies').doc(cid).collection('users').doc(user.uid), userData);
        await batch.commit();
        authMode = 'needs-verification';
        window.unverifiedEmail = email; // Für Anzeige direkt nach Registrierung
        if (typeof render === 'function') render();
    } catch (error) {
        alert("Registrierung fehlgeschlagen: " + error.message);
    }
};
window.resendVerification = async function() {
    const user = firebase.auth().currentUser;
    // Fall 1: User-Objekt ist noch frisch im Speicher (Direkt nach dem Login)
    if (user) try {
        await user.sendEmailVerification();
        window.showToast ? window.showToast("Ein neuer Link wurde an " + user.email + " gesendet.") : alert("Ein neuer Link wurde an " + user.email + " gesendet.");
    } catch (e) {
        console.error(e);
        alert("Fehler beim Senden. Bitte lade die Seite neu und melde dich noch einmal mit deinem Passwort an.");
    }
    else alert("Deine Anmelde-Sitzung ist abgelaufen. Bitte klicke unten auf 'Abmelden & Zur\xfcck' und melde dich noch einmal mit E-Mail und Passwort an. Danach wird automatisch ein neuer Link gesendet.");
};
window.handleLogin = async function() {
    const email = document.getElementById('loginEmail')?.value.trim();
    const pass = document.getElementById('loginPassword')?.value;
    if (!email || !pass) return alert("E-Mail/Passwort fehlen.");
    try {
        await firebase.auth().signInWithEmailAndPassword(email, pass);
    } catch (error) {
        alert("Fehler: " + error.message);
    }
};
window.logoutUser = function() {
    if (!firebase.auth().currentUser) return;
    if (authMode !== 'needs-verification' && !confirm("M\xf6chtest du dich wirklich abmelden?")) return;
    firebase.auth().signOut().then(()=>{
        window.currentUser = null;
        window.unverifiedEmail = null;
        localStorage.clear();
        authMode = 'landing';
        window.location.reload();
    });
};
/**
 * HTML GENERATOR
 */ function renderLoginHTML() {
    // -----------------------------------------
    // STATE 0: VERIFIZIERUNG ERFORDERLICH
    // -----------------------------------------
    if (authMode === 'needs-verification') return `
            <div class="h-screen flex items-center justify-center bg-slate-50 p-6 relative">
                <div class="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none">
                    <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-200 rounded-full mix-blend-multiply filter blur-[150px] opacity-20"></div>
                </div>
                
                <div class="relative z-50 bg-white w-full max-w-md rounded-[3rem] shadow-2xl p-10 md:p-12 text-center border border-slate-100 animate-fadeIn pointer-events-auto">
                    <div class="w-24 h-24 bg-blue-50 text-blue-600 rounded-[2rem] flex items-center justify-center mx-auto mb-8 shadow-inner border border-blue-100/50">
                        <i data-lucide="mail-check" class="w-12 h-12"></i>
                    </div>
                    <h2 class="text-3xl font-black text-slate-800 mb-4 tracking-tighter">Postfach pr\xfcfen!</h2>
                    <p class="text-slate-500 font-medium mb-10 leading-relaxed text-sm">
                        Wir haben einen Best\xe4tigungslink an<br><b class="text-slate-800">${window.unverifiedEmail || 'deine E-Mail'}</b> gesendet. <br><br>Bitte klicke auf den Link, um deinen Workspace zu aktivieren.
                    </p>
                    
                    <div class="space-y-4 relative z-50 pointer-events-auto">
                        <button onclick="window.location.reload()" class="w-full bg-blue-600 hover:bg-black text-white font-black py-4 rounded-2xl shadow-xl transition-all text-sm uppercase tracking-widest cursor-pointer">
                            Ich habe best\xe4tigt
                        </button>
                        <button onclick="window.resendVerification()" class="w-full bg-slate-50 hover:bg-slate-100 text-slate-600 font-bold py-4 rounded-2xl transition-all text-xs uppercase tracking-widest border border-slate-200 cursor-pointer">
                            Link erneut senden
                        </button>
                    </div>
                    
                    <button onclick="window.logoutUser()" class="mt-8 text-slate-400 hover:text-slate-600 font-bold text-[10px] uppercase tracking-[0.2em] transition-colors cursor-pointer relative z-50 pointer-events-auto">
                        Abmelden & Zur\xfcck
                    </button>
                </div>
            </div>
        `;
    // -----------------------------------------
    // STATE 1: LANDINGPAGE (SEO OPTIMIERT)
    // -----------------------------------------
    if (authMode === 'landing') {
        setTimeout(async ()=>{
            const stats = await window.fetchGlobalImpactStats();
            const co2El = document.getElementById('impact-co2');
            if (co2El) co2El.setAttribute('data-target', stats.co2);
            const treeEl = document.getElementById('impact-trees');
            if (treeEl) treeEl.setAttribute('data-target', stats.trees);
            const counters = document.querySelectorAll('.impact-counter');
            counters.forEach((counter)=>{
                const target = +counter.getAttribute('data-target');
                const inc = target / 100;
                let current = 0;
                const updateCount = ()=>{
                    if (current < target) {
                        current += inc;
                        counter.innerText = Math.ceil(current).toLocaleString('de-DE');
                        setTimeout(updateCount, 20);
                    } else counter.innerText = target.toLocaleString('de-DE');
                };
                updateCount();
            });
            if (window.lucide) lucide.createIcons();
        }, 100);
        return `
            <div id="landing-scroll-container" class="h-screen overflow-y-auto bg-slate-50 relative overflow-x-hidden font-sans flex flex-col scroll-smooth">
                
                <div class="absolute top-0 left-0 w-full h-[100vh] overflow-hidden z-0 pointer-events-none">
                    <div class="absolute -top-40 -right-40 w-[500px] h-[500px] bg-emerald-400 rounded-full mix-blend-multiply filter blur-[100px] opacity-20 animate-pulse"></div>
                    <div class="absolute top-40 -left-20 w-[600px] h-[600px] bg-blue-400 rounded-full mix-blend-multiply filter blur-[120px] opacity-20" style="animation: pulse 4s infinite reverse;"></div>
                </div>

                <nav class="sticky top-0 w-full bg-white/80 backdrop-blur-xl z-50 border-b border-slate-100/50">
                    <div class="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
                        
                        <div class="flex items-center gap-3 cursor-pointer group" onclick="window.scrollToSection('top')">
                            <div class="w-10 h-10 bg-slate-800 rounded-xl flex items-center justify-center text-white shadow-lg shadow-slate-800/20 group-hover:bg-blue-600 transition-colors">
                                <i data-lucide="layers" class="w-5 h-5"></i>
                            </div>
                            <span class="font-black text-2xl tracking-tighter text-slate-800 uppercase group-hover:text-blue-600 transition-colors">Pre<span class="text-blue-600 group-hover:text-slate-800 transition-colors">senzo</span></span>
                        </div>

                        <div class="flex gap-4 items-center">
                            <button onclick="window.scrollToSection('features')" class="text-slate-500 hover:text-slate-800 font-bold text-sm hidden md:block px-4 py-2 transition-colors">Software Features</button>
                            <button onclick="authMode='login'; render()" class="bg-slate-800 text-white px-8 py-3 rounded-2xl font-black text-[10px] uppercase tracking-widest hover:bg-blue-600 transition-all shadow-xl hover:shadow-blue-500/30 flex items-center gap-2">
                                Anmelden <i data-lucide="arrow-right" class="w-3 h-3"></i>
                            </button>
                        </div>
                    </div>
                </nav>

                <main class="flex-1 relative z-10">
                    <section class="pt-20 pb-20 px-6 flex flex-col justify-center min-h-[85vh]">
                        <div class="max-w-5xl mx-auto text-center mt-10">
                            
                            <!-- 1. Vertrauen & Dringlichkeit -->
                            <div class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-slate-200 text-slate-600 text-[10px] font-black uppercase tracking-widest mb-8 shadow-sm">
                                <i data-lucide="shield-check" class="w-3 h-3 text-emerald-500"></i> Erf\xfcllt die CSRD-Berichtspflicht ab 2025
                            </div>
                            
                            <!-- 2. WAS MACHT ES? -->
                            <h1 class="text-5xl md:text-7xl lg:text-[5rem] font-black text-slate-800 tracking-tighter leading-[1.1] mb-6">
                                B\xfcroauslastung steuern.<br>
                                <span class="text-transparent bg-clip-text bg-gradient-to-r from-emerald-500 to-blue-600">Scope 3.7 automatisch bilanzieren.</span>
                            </h1>
                            
                            <!-- 3. F\xdcR WEN & WAS IST DER VORTEIL? -->
                            <p class="text-lg md:text-xl text-slate-500 font-medium max-w-2xl mx-auto mb-10 leading-relaxed">
                                F\xfcr HR & Sustainability Manager: Organisiert das Desk-Sharing f\xfcr hybride Teams und erhaltet die exakten CO\u{2082}-Pendlerdaten als Audit-sicheres Nebenprodukt. <strong class="text-slate-700">100% pr\xe4zise. 0% l\xe4stige Mitarbeiterumfragen.</strong>
                            </p>

                            <!-- 4. CALL TO ACTION -->
                            <div class="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16 relative z-50">
                                <button onclick="authMode='register'; if(typeof render === 'function') render(); window.scrollTo(0,0);" class="w-full sm:w-auto bg-blue-600 text-white px-8 py-4 rounded-2xl font-black text-sm uppercase tracking-widest hover:bg-black transition-all shadow-xl hover:shadow-blue-500/30 flex items-center justify-center gap-2">
                                    Kostenlos starten <i data-lucide="arrow-right" class="w-4 h-4"></i>
                                </button>
                                <button onclick="window.scrollToSection('features')" class="w-full sm:w-auto bg-white text-slate-700 border border-slate-200 px-8 py-4 rounded-2xl font-black text-sm uppercase tracking-widest hover:bg-slate-50 transition-all shadow-sm">
                                    So funktioniert's
                                </button>
                            </div>

                            <!-- Counters -->
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-2xl mx-auto mt-4">
                                <div class="bg-white p-10 rounded-[3rem] shadow-2xl border border-slate-100 transform hover:-translate-y-2 transition-all">
                                    <div class="w-16 h-16 bg-blue-50 text-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                                        <i data-lucide="cloud" class="w-8 h-8"></i>
                                    </div>
                                    <h3 class="text-6xl font-black text-slate-800 mb-2 flex items-baseline justify-center gap-1">
                                        <span id="impact-co2" class="impact-counter" data-target="0">0</span>
                                        <span class="text-2xl text-slate-400">kg</span>
                                    </h3>
                                    <p class="text-[11px] font-black uppercase text-slate-400 tracking-[0.2em]">Scope 3.7 CO\u{2082} erfasst*</p>
                                </div>

                                <div class="bg-white p-10 rounded-[3rem] shadow-2xl border border-slate-100 transform hover:-translate-y-2 transition-all relative overflow-hidden group">
                                    <div class="absolute -right-8 -bottom-8 opacity-[0.05] group-hover:scale-110 transition-transform duration-700"><i data-lucide="leaf" class="w-48 h-48"></i></div>
                                    <div class="w-16 h-16 bg-emerald-50 text-emerald-600 rounded-2xl flex items-center justify-center mx-auto mb-6 relative z-10">
                                        <i data-lucide="tree-pine" class="w-8 h-8"></i>
                                    </div>
                                    <h3 class="text-6xl font-black text-slate-800 mb-2 relative z-10">
                                        <span id="impact-trees" class="impact-counter" data-target="0">0</span>
                                    </h3>
                                    <p class="text-[11px] font-black uppercase text-slate-400 tracking-[0.2em]">Kompensations-\xc4quivalent*</p>
                                </div>
                            </div>
                            
                            <p class="text-[10px] text-slate-400 mt-12 font-bold uppercase tracking-widest opacity-60">
                                *Echtzeit-Aggregation aller registrierten Presenzo-Workspaces.
                            </p>
                        </div>
                    </section>

                    <section id="features" class="py-24 px-6 bg-slate-50 relative z-10 border-t border-slate-200/50">
                        <div class="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
                            
                            <div class="bg-white p-10 md:p-12 rounded-[2.5rem] shadow-sm border border-slate-200/60 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                                <div class="w-12 h-12 bg-blue-100 text-blue-600 rounded-xl flex items-center justify-center mb-6">
                                    <i data-lucide="users" class="w-6 h-6"></i>
                                </div>
                                <h3 class="text-2xl font-black text-slate-800 mb-4">Smarte Desk- & Office-Planung</h3>
                                <p class="text-slate-500 font-medium leading-relaxed">
                                    Verwalte hybride Teams und Desk-Sharing nahtlos. Ein transparenter Team-Kalender zeigt in Echtzeit, wer an welchem Tag im B\xfcro oder im Homeoffice arbeitet.
                                </p>
                            </div>

                            <div class="bg-white p-10 md:p-12 rounded-[2.5rem] shadow-sm border border-slate-200/60 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group">
                                <div class="absolute -right-8 -bottom-8 opacity-5 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500"><i data-lucide="leaf" class="w-48 h-48 text-emerald-500"></i></div>
                                <div class="w-12 h-12 bg-emerald-100 text-emerald-600 rounded-xl flex items-center justify-center mb-6 relative z-10">
                                    <i data-lucide="leaf" class="w-6 h-6"></i>
                                </div>
                                <h3 class="text-2xl font-black text-slate-800 mb-4 relative z-10">Audit-sicheres CSRD-Reporting</h3>
                                <p class="text-slate-500 font-medium leading-relaxed relative z-10">
                                    Erfasse Mitarbeiter-Pendelwege (Commuting) auf Basis echter Prim\xe4rdaten. Generiere l\xfcckenlose Scope 3 Kategorie 7 Berichte f\xfcr deinen Wirtschaftspr\xfcfer.
                                </p>
                            </div>

                            <div class="bg-white p-10 md:p-12 rounded-[2.5rem] shadow-sm border border-slate-200/60 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                                <div class="w-12 h-12 bg-purple-100 text-purple-600 rounded-xl flex items-center justify-center mb-6">
                                    <i data-lucide="sliders-horizontal" class="w-6 h-6"></i>
                                </div>
                                <h3 class="text-2xl font-black text-slate-800 mb-4">Compliance & Team-Limits</h3>
                                <p class="text-slate-500 font-medium leading-relaxed">
                                    Definiere unternehmensweite Quoten f\xfcr mobiles Arbeiten. Sorge f\xfcr eine optimale B\xfcroauslastung und automatisiere Genehmigungsworkflows rechtssicher.
                                </p>
                            </div>

                            <div class="bg-white p-10 md:p-12 rounded-[2.5rem] shadow-sm border border-slate-200/60 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                                <div class="w-12 h-12 bg-slate-100 text-slate-700 rounded-xl flex items-center justify-center mb-6">
                                    <i data-lucide="shield-check" class="w-6 h-6"></i>
                                </div>
                                <h3 class="text-2xl font-black text-slate-800 mb-4">DSGVO Cloud-Sicherheit</h3>
                                <p class="text-slate-500 font-medium leading-relaxed">
                                    Die Daten deines Teams sind durch h\xf6chste europ\xe4ische Datenschutz-Standards gesichert. Nutze unsere Widgets, um eure Employer-Branding Erfolge sicher zu teilen.
                                </p>
                            </div>

                        </div>
                    </section>
                </main>

                <footer class="bg-white border-t border-slate-200 py-8 mt-auto shrink-0 z-20">
                    <div class="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
                        <div class="flex items-center gap-2 cursor-pointer group" onclick="window.scrollToSection('top')">
                            <div class="w-6 h-6 bg-slate-800 rounded-md flex items-center justify-center text-white group-hover:bg-blue-600 transition-colors">
                                <i data-lucide="layers" class="w-3 h-3"></i>
                            </div>
                            <span class="font-black text-sm tracking-tighter text-slate-800 uppercase group-hover:text-blue-600 transition-colors">Presenzo</span>
                        </div>
                        
                        <p class="text-xs font-medium text-slate-400">
                            &copy; ${new Date().getFullYear()} Presenzo. Alle Rechte vorbehalten.
                        </p>
                        
                        <div class="flex items-center gap-6 text-xs font-medium text-slate-500">
                            <button onclick="window.showLegalModal('impressum')" class="hover:text-slate-800 transition-colors">Impressum</button>
                            <button onclick="window.showLegalModal('datenschutz')" class="hover:text-slate-800 transition-colors">Datenschutz</button>
                        </div>
                    </div>
                </footer>
            </div>
        `;
    }
    // -----------------------------------------
    // STATE 2: LOGIN & REGISTER FORMULARE
    // -----------------------------------------
    let content = '';
    if (authMode === 'login') content = `
            <div class="flex justify-between items-center mb-6">
                <h2 class="text-3xl font-black text-slate-800">Willkommen</h2>
                <button onclick="authMode='landing'; window.render()" class="text-slate-400 hover:text-slate-600 transition-colors"><i data-lucide="x" class="w-6 h-6"></i></button>
            </div>
            <p class="text-slate-500 mb-8 text-sm font-medium">Melde dich an, um deinen Workspace zu verwalten.</p>
            
            <form onsubmit="event.preventDefault(); window.handleLogin();" class="space-y-4">
                <input type="email" id="loginEmail" placeholder="E-Mail" autocomplete="username" class="w-full px-4 py-4 rounded-2xl border border-slate-200 font-bold outline-none focus:border-blue-500 transition-all">
                
                <input type="password" id="loginPassword" placeholder="Passwort" autocomplete="current-password" class="w-full px-4 py-4 rounded-2xl border border-slate-200 font-bold outline-none focus:border-blue-500 transition-all">
                
                <button type="submit" class="w-full bg-blue-600 hover:bg-black text-white font-black py-4 rounded-2xl transition-all shadow-lg mt-2">Anmelden</button>
                
                <div class="flex justify-between text-xs font-bold mt-6">
                    <a href="#" class="text-blue-600 hover:text-blue-800 transition-colors">Passwort vergessen?</a>
                    <a href="#" onclick="authMode='register'; window.render()" class="text-slate-400 hover:text-slate-600 transition-colors">Neuer Workspace?</a>
                </div>
            </form>
        `;
    else if (authMode === 'register') content = `
            <div class="flex justify-between items-center mb-6">
                <h2 class="text-3xl font-black text-slate-800">Workspace erstellen</h2>
                <button onclick="authMode='landing'; window.render()" class="text-slate-400 hover:text-slate-600 transition-colors"><i data-lucide="x" class="w-6 h-6"></i></button>
            </div>
            <p class="text-slate-500 mb-6 text-xs font-medium uppercase tracking-widest">Schritt 1: Unternehmens-Profil</p>
            
            <form onsubmit="event.preventDefault(); window.handleRegister();">
                <div class="space-y-3 max-h-[50vh] overflow-y-auto pr-2 custom-scrollbar">
                    <div class="grid grid-cols-2 gap-3">
                        <input type="text" id="regFirst" placeholder="Vorname *" class="px-4 py-3 rounded-xl border border-slate-200 font-bold text-sm outline-none focus:border-blue-500">
                        <input type="text" id="regLast" placeholder="Nachname *" class="px-4 py-3 rounded-xl border border-slate-200 font-bold text-sm outline-none focus:border-blue-500">
                    </div>
                    
                    <input type="text" id="regCompany" placeholder="Firmenname *" class="w-full px-4 py-3 rounded-xl border border-slate-200 font-bold text-sm outline-none focus:border-blue-500">
                    
                    <div class="grid grid-cols-[3fr_1fr] gap-3">
                        <input type="text" id="regStreet" placeholder="Stra\xdfe *" class="px-4 py-3 rounded-xl border border-slate-200 font-bold text-sm outline-none focus:border-blue-500">
                        <input type="text" id="regStreetNo" placeholder="Nr. *" class="px-4 py-3 rounded-xl border border-slate-200 font-bold text-sm outline-none focus:border-blue-500">
                    </div>
                    <div class="grid grid-cols-[1fr_2fr] gap-3">
                        <input type="text" id="regZip" placeholder="PLZ *" class="px-4 py-3 rounded-xl border border-slate-200 font-bold text-sm outline-none focus:border-blue-500">
                        <input type="text" id="regCity" placeholder="Stadt *" class="px-4 py-3 rounded-xl border border-slate-200 font-bold text-sm outline-none focus:border-blue-500">
                    </div>
                    <input type="text" id="regCountry" placeholder="Land" class="w-full px-4 py-3 rounded-xl border border-slate-200 font-bold text-sm outline-none focus:border-blue-500" value="Deutschland">

                    <div class="space-y-1">
                        <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest ml-1">Zeitzone *</label>
                        <select id="regTimezone" class="w-full px-4 py-3 rounded-xl border border-slate-200 font-bold text-sm outline-none focus:border-blue-500 bg-white">
                            <option value="Europe/Berlin" selected>Europe/Berlin (GMT+1)</option>
                            <option value="Europe/London">Europe/London (GMT+0)</option>
                            <option value="America/New_York">America/New_York (GMT-5)</option>
                        </select>
                    </div>

                    <hr class="my-4 border-slate-100">
                    <input type="email" id="regEmail" placeholder="E-Mail Adresse *" autocomplete="username" class="w-full px-4 py-3 rounded-xl border border-slate-200 font-bold text-sm outline-none focus:border-blue-500">
                    <input type="password" id="regPass" placeholder="Passwort w\xe4hlen *" autocomplete="new-password" class="w-full px-4 py-3 rounded-xl border border-slate-200 font-bold text-sm outline-none focus:border-blue-500">
                </div>

                <button type="submit" class="w-full bg-blue-600 hover:bg-black text-white font-black py-4 rounded-2xl transition-all shadow-lg mt-6">Workspace starten</button>
            </form>
            <p class="text-center text-xs font-bold mt-4 text-slate-400">Schon dabei? <a href="#" onclick="authMode='login'; window.render()" class="text-blue-600 hover:text-blue-800 transition-colors">Zum Login</a></p>
        `;
    return `
        <div id="landing-scroll-container" class="h-screen overflow-y-auto flex items-center justify-center bg-slate-50 p-6 relative">
            <div class="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none">
                <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-200 rounded-full mix-blend-multiply filter blur-[150px] opacity-20"></div>
            </div>
            
            <div class="bg-white w-full max-w-lg rounded-[2.5rem] shadow-2xl border border-slate-100 p-8 md:p-12 animate-fadeIn relative z-10">
                <div class="flex justify-center mb-6">
                    <div class="bg-slate-800 w-12 h-12 rounded-2xl shadow-xl flex items-center justify-center text-white">
                        <i data-lucide="layers" class="w-6 h-6"></i>
                    </div>
                </div>
                ${content}
            </div>
        </div>
    `;
}
// Global verfügbar machen
window.handleLogin = handleLogin;
window.handleRegister = handleRegister;
window.logoutUser = logoutUser;
window.resendVerification = resendVerification;

//# sourceMappingURL=frontend.5b8f534d.js.map
